<template>
  <el-dialog
    :title="$t('shopConfig.edit')"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose">
    <div class="modal-body">
      <div class="ibox-content">
        <el-form :model="editShopConfigInfo" label-width="120px">
          <el-form-item :label="$t('shopConfig.startTime')" prop="ostartTime">
            <el-time-picker
              v-model="editShopConfigInfo.ostartTime"
              style="width:100%"
              :placeholder="$t('shopConfig.inputStartTime')"
              value-format="HH:mm:ss">
            </el-time-picker>
          </el-form-item>

          <el-form-item :label="$t('shopConfig.endTime')" prop="oendTime">
            <el-time-picker
              v-model="editShopConfigInfo.oendTime"
              style="width:100%"
              :placeholder="$t('shopConfig.inputEndTime')"
              value-format="HH:mm:ss">
            </el-time-picker>
          </el-form-item>

          <el-form-item :label="$t('shopConfig.deliveryMethod')" prop="sendWay">
            <el-select
              v-model="editShopConfigInfo.sendWay"
              style="width:100%"
              :placeholder="$t('shopConfig.selectDeliveryMethod')">
              <el-option disabled value="">{{ $t('shopConfig.selectDeliveryMethod') }}</el-option>
              <el-option value="SHOP" :label="$t('shopConfig.selfDelivery')">{{ $t('shopConfig.selfDelivery') }}</el-option>
              <el-option value="USER" :label="$t('shopConfig.storeVerification')">{{ $t('shopConfig.storeVerification') }}</el-option>
            </el-select>
          </el-form-item>

          <el-form-item 
            v-if="editShopConfigInfo.sendWay == 'SHOP'" 
            :label="$t('shopConfig.deliveryFee')" 
            prop="sendFee">
            <el-input
              v-model="editShopConfigInfo.sendFee"
              :placeholder="$t('shopConfig.inputDeliveryFee')">
            </el-input>
          </el-form-item>
        </el-form>

        <div class="ibox-content text-right">
          <el-button type="warning" @click="handleClose" style="margin-right:20px;">
            {{ $t('common.cancel') }}
          </el-button>
          <el-button type="primary" @click="editShopConfig">
            {{ $t('common.save') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { updateShopConfig } from '@/api/shop/shopConfigApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditShopConfig',
  data() {
    return {
      dialogVisible: false,
      editShopConfigInfo: {
        scId: '',
        shopId: '',
        ostartTime: '',
        oendTime: '',
        sendWay: '',
        sendFee: '0'
      }
    }
  },
  methods: {
    open(data) {
      console.log(data)
      this.resetForm()
      this.editShopConfigInfo = { ...data }
      // 如果时间格式是 HH:mm，则添加 :00；如果已经是 HH:mm:ss，则不添加
      if (this.editShopConfigInfo.ostartTime && this.editShopConfigInfo.ostartTime.split(':').length === 2) {
        this.editShopConfigInfo.ostartTime = this.editShopConfigInfo.ostartTime + ':00'
      }
      if (this.editShopConfigInfo.oendTime && this.editShopConfigInfo.oendTime.split(':').length === 2) {
        this.editShopConfigInfo.oendTime = this.editShopConfigInfo.oendTime + ':00'
      }
      this.editShopConfigInfo.shopId = getShopId()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    resetForm() {
      this.editShopConfigInfo = {
        scId: '',
        shopId: '',
        ostartTime: '',
        oendTime: '',
        sendWay: '',
        sendFee: '0'
      }
    },
    editShopConfig() {
      if (!this.validateForm()) {
        return
      }

      updateShopConfig(this.editShopConfigInfo).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('common.saveSuccess'))
          this.handleClose()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    validateForm() {
      if (!this.editShopConfigInfo.ostartTime) {
        this.$message.warning(this.$t('shopConfig.startTimeRequired'))
        return false
      }
      if (!this.editShopConfigInfo.oendTime) {
        this.$message.warning(this.$t('shopConfig.endTimeRequired'))
        return false
      }
      if (!this.editShopConfigInfo.sendWay) {
        this.$message.warning(this.$t('shopConfig.deliveryMethodRequired'))
        return false
      }
      if (this.editShopConfigInfo.sendWay == 'SHOP' && !this.editShopConfigInfo.sendFee) {
        this.$message.warning(this.$t('shopConfig.deliveryFeeRequired'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
/* 样式与editShopSmsSwitch.vue保持一致 */
</style>